import { Divider, Stack } from '@mui/material';
import React from 'react';
import ViewHeader from './ViewHeader';

export default ({ header, row1, row2 }: IViewControlsProps) => (
    <Stack sx={{ height: 105 }}> 
        <ViewHeader text={header}>{row1}</ViewHeader>

        {row2}

        <Divider flexItem />
    </Stack>
);

export interface IViewControlsProps {
    header: string | JSX.Element;
    row1?: JSX.Element;
    row2?: JSX.Element;
}
